import { jsx as _jsx } from "react/jsx-runtime";
import { TruncatedTextValue } from "../text/TruncatedTextValue.js";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledTextValue = ({ lines = 3, label, text, showMoreLabel, showLessLabel, notSetLabel, }) => {
    return (_jsx(LabeledValue, { label: label, children: _jsx(TruncatedTextValue, { text: text?.trim(), lines: lines, showMoreLabel: showMoreLabel, showLessLabel: showLessLabel, notSetLabel: notSetLabel }) }));
};
//# sourceMappingURL=LabeledTextValue.js.map